import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import HybridBasicLayout from '../../layout/basic/hybrid.basic.layout.vue';
import StackedOverflow from '../../../shared/StackedOverflow/stacked.overflow.vue';
import ASpaceInBetweenAnother from '../../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import { CommonConfig } from '../../../configs/config.common';
import HybridButtonOne from '../../../hybrid/shared/HybridButtonOne/HybridButtonOne.vue';
import GoBackArrow from '../../shared/GoBackArrow/go.back.arrow.vue';
import { EpicContextService } from '../../../services/EpicContextService/epic.context';
import { UserInfoDelegate } from '../../services/DataDelegate/UserDelegate/user.info.delegate';
import * as T_T from 'cryface';
import { AxiosPromise } from '../../../utils/axios.promise';
import * as moment from 'moment';
import CouponStatus from '../../mixins/coupon.status.mixin';
import { CallNative } from '../../../services/EpicContextService/call.native';
import CreateMonerisOrder from '../../shared/CreateMonerisOrder/create.moneris.order.vue';
import { getCondition } from '../../../utils/price.condition';

@Component({
    components: {
        'layout': HybridBasicLayout,
        StackedOverflow,
        ASpaceInBetweenAnother,
        HybridButtonOne,
        GoBackArrow,
        CreateMonerisOrder
    },
    mixins: [CouponStatus],
})
export default class HybridCouponDetail extends Vue {

    public configs = new CommonConfig();

    public status: number = 0;

    public img = '';

    public title = '';

    public subtitle = '';

    public price = 0;

    public priceInfo = '';

    public expiryDate = '';

    public fjjUserId: any = null;

    public respartnerId: any = null;

    public couponIns: any = null;

    public userInfoDelegate = new UserInfoDelegate();

    public customerServiceCall = this.configs.rifoContactPhone;

    public loading = true;

    public orderId = '';

    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(val: any, oldVal: any) {
        if (T_T.simpleDetect(val.context)) {
            const fjjUserId = val.getParam('fjjUserId');
            if (T_T.simpleDetect(fjjUserId)) {
                this.fjjUserId = fjjUserId;
                const userInfo = await this.userInfoDelegate.getUserInfo(this.fjjUserId);
                this.respartnerId = userInfo.resPartnerId;
                if (!T_T.simpleDetect(this.respartnerId)) {
                    alert(
                        this.$t('17')
                    );
                }
                this.refreshPageInfo(this.respartnerId);
                return;
            }
        }
        this.refreshPageInfo(null);
    }
    public contents = [];

    public async created() {
        if (localStorage) {
            localStorage.setItem('rifo_coupon_id', this.$route.params['id']);
        }
        CallNative.setNativeNavTitle('优惠券详情', 'Coupon Detail');
    }
    public async refreshPageInfo(respartnerId: any) {
        const id = this.$route.params['id'];
        const couponApi = this.configs.couponService;
        const url = !respartnerId ?
            `${couponApi}/coupon/detailwithIns?couponId=${id}`
            : `${couponApi}/coupon/detailwithIns?couponId=${id}&partnerId=${respartnerId}`;
        const fetched = await AxiosPromise.get(url);
        if (fetched.errorCode === 200) {
            const language = T_T.simpleDetect(this.globalPudge.getParam('language')) ? this.globalPudge.getParam('language')!.value : 1;
            const data = fetched.data;
            const coupon = data.coupon;
            this.img = coupon.coverImgs[0];
            this.contents = language === 1 ? (T_T.simpleDetect(coupon.descEn) ? coupon.descEn : '') : (T_T.simpleDetect(coupon.descCn) ? coupon.descCn : '');
            const ins = data.ins;
            this.title = language === 1 ? (T_T.simpleDetect(coupon.xNameEn) ? coupon.xNameEn
                : this.$t('18')) : (T_T.simpleDetect(coupon.xNameCn) ? coupon.xNameCn : this.$t('18'));
            this.subtitle = T_T.simpleDetect(coupon.xTagline) ? coupon.xTagline : this.$t('19');
            this.price = T_T.simpleDetect(coupon.xPrice) ? coupon.xPrice : 0;
            this.expiryDate = T_T.simpleDetect(coupon.xExpiredDate) ? moment(coupon.xExpiredDate).format(this.configs.dateFormat) : '';
            this.couponIns = ins;
            this.priceInfo = getCondition(
                coupon.xCategory,
                coupon.xDiscountPercent,
                coupon.xDiscountAmount,
                coupon.xRequestedAmount,
                this.$i18n.locale);
            if (ins && ins.length) {
                this.status = ins[0].xStatus;
            }
            this.loading = false;
        }

    }
    public async mounted() {
    }

    public getRifoAssets(path: string) {
        return `${this.configs.rifoDesignAssetsUrl}/${path}`;
    }

    public getButtonText() {
        if (!this.fjjUserId) {
            return (this.$t('20'));
        }
        if (!this.couponIns ||
            (this.couponIns && this.couponIns.length === 0)) {
            return (this.$t('45'));
        }
        switch (this.status) {
            case this.COUPON_INSTANCE_STATUS['UNPAID']: {
                return (this.$t('22'));
                break;
            }
            case this.COUPON_INSTANCE_STATUS['READY_TO_USE']: {
                return (this.$t('44'));
                break;
            }
            case this.COUPON_INSTANCE_STATUS['USED']: {
                return (this.$t('24'));
                break;
            }
            case this.COUPON_INSTANCE_STATUS['EXPIRED']: {
                // 不可点
                return (this.$t('25'));
                break;
            }
            case this.COUPON_INSTANCE_STATUS['REFUNDED']: {
                // 不可点
                return (this.$t('26'));
                break;
            }
            case this.COUPON_INSTANCE_STATUS['DISCARDED']: {
                // 不可点
                return (this.$t('27'));
                break;
            }
            default:
                break;
        }
    }

    public async timeout(ms: number): Promise<any> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    public async nav() {
        if (!this.fjjUserId) {
            // Go Login
            CallNative.runNativeFun('nativeGoRegister');
            return;
        }
        if (!this.couponIns ||
            (this.couponIns && this.couponIns.length === 0)) {
            return;
        }
        switch (this.status) {
            case this.COUPON_INSTANCE_STATUS['UNPAID']: {
                (this.$refs.monerisForm1 as any).monerisSubmit();
                break;
            }
            case this.COUPON_INSTANCE_STATUS['READY_TO_USE']: {
                // 预约
                this.$router.push(`/hybrid/services/appointment/${this.couponIns[0].id}`);
                break;
            }
            case this.COUPON_INSTANCE_STATUS['USED']: {
                // 我的订单
                CallNative.runNativeFun('nativeGoOrder');
                break;
            }
            case this.COUPON_INSTANCE_STATUS['EXPIRED']: {
                // 过期: Do Nothing
                break;
            }
            case this.COUPON_INSTANCE_STATUS['REFUNDED']: {
                // 退款: Do Nothing
                break;
            }
            case this.COUPON_INSTANCE_STATUS['DISCARDED']: {
                // 删除: Do Nothing
                break;
            }
        }
    }
}
